import {APIClient} from "../../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Register Method
export const postFakeRegister = (data: any) =>
    api.create(url.POST_FAKE_REGISTER, data);

// Register Method
export const postJwtRegister = (url: string, data: any) => {
    return api.create(url, data).catch((err) => {
        var message;
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 404:
                    message = "Sorry! the page you are looking for could not be found";
                    break;
                case 500:
                    message =
                        "Sorry! something went wrong, please contact our support team";
                    break;
                case 401:
                    message = "Invalid credentials";
                    break;
                default:
                    message = err[1];
                    break;
            }
        }
        throw message;
    });
};
